import { ClientSafeLaunchCertificateViewV1Schema, LaunchCertificateArtifactV1Schema, LaunchCertificateVerificationCodeSchema, } from "../contracts/launch-certificate.js";
import { LAUNCH_CERTIFICATE_DISCLAIMERS, LAUNCH_CERTIFICATE_HEADLINE_ISSUED, LAUNCH_CERTIFICATE_TITLE, } from "./launch-certificate-copy.js";
import { toClientSafeLaunchCertificateView } from "./sanitize-client-safe-launch-certificate.js";
/** Static sample artifact — no real tenant data; browser-safe. */
export const SAMPLE_LAUNCH_CERTIFICATE_ARTIFACT = LaunchCertificateArtifactV1Schema.parse({
    schemaVersion: "launch-certificate-artifact.v1.0",
    certificateId: "lcert_sample_demo_only",
    verificationCode: LaunchCertificateVerificationCodeSchema.parse("lcert_0123456789abcdef0123456789abcdef"),
    status: "ISSUED",
    businessName: "Example Client Site — illustrative only",
    agencyDisplayName: "Your Agency Name",
    proofReferenceLabel: "Launch proof reference: LP-SAMPLE-2026",
    aggregateStatus: "ready",
    aggregateStatusLabel: "Evaluated checks passed at this reference",
    headline: LAUNCH_CERTIFICATE_HEADLINE_ISSUED,
    evidenceSections: [
        {
            schemaVersion: "launch-certificate-evidence-section.v1.0",
            areaLabel: "Language hygiene",
            statusLabel: "Passed",
            summary: "Sample section — illustrative only.",
        },
        {
            schemaVersion: "launch-certificate-evidence-section.v1.0",
            areaLabel: "Lead path",
            statusLabel: "Passed",
            summary: "Sample section — illustrative only.",
        },
    ],
    warningBanner: null,
    issuedAt: "2026-01-15T12:00:00.000Z",
    disclaimers: [...LAUNCH_CERTIFICATE_DISCLAIMERS],
});
export function sampleClientSafeLaunchCertificateView() {
    return ClientSafeLaunchCertificateViewV1Schema.parse(toClientSafeLaunchCertificateView(SAMPLE_LAUNCH_CERTIFICATE_ARTIFACT));
}
export function sampleLaunchCertificateViewWithTitle() {
    return ClientSafeLaunchCertificateViewV1Schema.parse({
        ...sampleClientSafeLaunchCertificateView(),
        title: LAUNCH_CERTIFICATE_TITLE,
    });
}
//# sourceMappingURL=sample-launch-certificate.js.map